<script lang="ts" setup>
  const open = defineModel<boolean>({ default: false })

  const infoUrl = 'https://ouraring.atlassian.net/wiki/spaces/IT/pages/6577815809/How-to+-+Understanding+Twingate'
</script>

<template lang="html">
  <v-dialog v-model="open" scrollable width="800">
    <v-card>
      <v-card-item>
        <template #prepend>
          <v-icon class="mr-2" color="error" icon="mdi-lan-disconnect" />
        </template>

        <v-card-title>Can't reach cloud services</v-card-title>
      </v-card-item>

      <v-divider />

      <v-card-text>
        <p>Health check to the cloud backend failed. This could be due to a few reasons.</p>

        <p>Things to check:</p>

        <ol class="pl-4">
          <li class="mb-3">
            <strong>Twingate disconnected.</strong>
            Open the Twingate client and confirm you're connected. Also check that you see the
            <b>OuraHub resources</b>
            , if not try to re-login or contact IT.
          </li>

          <li class="mb-3">
            <strong>Chrome "Local network" permission.</strong>
            Click
            <v-icon size="small" icon="mdi-tune-variant" />
            at the left of the address bar and toggle "Local network"
            <v-icon size="small" icon="mdi-router-wireless-off" />
            on, then reload.
          </li>

          <li class="mb-3">
            <strong>Oura tooling backend temporarily down.</strong>
            The backend the health check relies on might be down. Check
            <strong>#help-oura-tooling</strong>
            for known service breaks.
          </li>

          <li>
            <strong>Something else.</strong>
            DNS, proxy, ad-blocker, browser extension or a network issue. Check the Network tab for the real status
            code.
          </li>
        </ol>

        <p class="mt-4">
          Still stuck? Ping
          <strong>#help-oura-tooling</strong>
          with your Chrome console output for help.
        </p>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <o-btn-secondary target="_blank" rel="noopener noreferrer" :href="infoUrl">
          Understanding Twingate
        </o-btn-secondary>

        <v-spacer />

        <o-btn-primary @click="open = false">Close</o-btn-primary>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
